import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(t("common.success"));
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("common.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-[#FAFAFA] px-6">
        <div className="w-full max-w-md card-premium p-10">
          <h1 className="font-display font-bold text-3xl text-slate-900">{t("auth.resetTitle")}</h1>
          <p className="mt-2 text-slate-600 text-sm">{t("auth.resetSub")}</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <input
              type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)}
              placeholder={t("auth.newPw")}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none transition"
              data-testid="reset-password"
            />
            <button disabled={loading || !token} className="btn-primary w-full rounded-full px-6 py-3 font-semibold" data-testid="reset-submit">
              {loading ? t("common.loading") : t("auth.reset")}
            </button>
          </form>
          <div className="mt-6 text-sm"><Link to="/login" className="text-[#0A192F] hover:underline">{t("common.back")}</Link></div>
        </div>
      </main>
    </>
  );
}
